module.exports = __webpack_public_path__ + "img/154.f4bb1910.png";